import React, { FC, useState } from 'react';
import { createUseStyles } from '../theming';

const useStyles = createUseStyles((theme) => ({
  root: {
    marginBottom: 0,
    '& > span': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontWeight: 'bold',
      marginLeft: 5,
    },
  },
}));

interface Props {
  text: string;
  maxTextLenght?: number;
}

const ReadMore: FC<Props> = ({ text, maxTextLenght = 150 }) => {
  const [isReadMore, setIsReadMore] = useState(text.length >= maxTextLenght);
  const classes = useStyles();

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  return (
    <p className={classes.root}>
      {isReadMore ? text.slice(0, maxTextLenght) : text}
      {text.length >= maxTextLenght && <span onClick={toggleReadMore}>{isReadMore ? '... lire plus' : 'réduire'}</span>}
    </p>
  );
};

export default ReadMore;
